<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">CNA BOX</a></li>
                            <li>Alíquota Simples Nacional</li>
                        </ul>
                    </section>

                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Criar Alíquota Simples Nacional</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form-create v-if="dialogCreate" @on-saved="onSaved" @on-back="onBack()" />
                    </div>

                </div>
            </div>
        </section>


    </main>

</template>
<script>

    import formCreate from './form-create'

    export default {
        name: 'aliquotasimplesnacional-create',
        components: { formCreate },
        data: () => ({
            dialogCreate: false,
        }),
        methods: {
            onSaved: function (data) {
                this.$router.push({ path: '/aliquotasimplesnacional/edit/' + data.data.aliquotaSimplesNacionalId });
            },
            onBack: function () {
                this.$router.go(-1);
            }
        },
        mounted() {
            this.dialogCreate = true;
        }
    };
</script>

